import { z } from 'zod';
import { InspectionCornSchema, InspectionEntityCornSchema } from '../base.js';
export const RawFloorplanCaptureSchema = z.object({
    captureId: z.uuid(),
    entityId: InspectionEntityCornSchema,
    inspectionId: InspectionCornSchema,
    rawOutput: z.unknown(),
});
/** Dynamo item shape: payload may live inline (legacy) or behind `s3Key`. */
export const RawFloorplanRecordSchema = z
    .object({
    captureId: z.uuid(),
    entityId: InspectionEntityCornSchema,
    inspectionId: InspectionCornSchema,
    s3Key: z.string().optional(),
    rawOutput: z.unknown().optional(),
})
    .refine((record) => record.s3Key !== undefined || record.rawOutput !== undefined, {
    message: 'RawFloorplanRecord requires s3Key or rawOutput',
});
